/* eslint-disable react/no-array-index-key */
/* eslint-disable no-unused-vars */
/* eslint-disable no-param-reassign */
import React, { Fragment } from 'react';
import { WithWizard } from 'react-albus';
import { NavLink } from 'react-router-dom';

const TopNavigation = ({ className, disableNav, topNavClick, aiva }) => {

  const getClassName = (steps, step, index, stepItem) => {
    if (steps.indexOf(step) === index) {
      return 'step-doing';
    }
    if (steps.indexOf(step) > index || stepItem.isDone) {
      stepItem.isDone = true;
      return 'step-done';
    }
    return 'step';
  };

  const itemClick = (stepItem, push) => {
    if (disableNav) {
      return;
    }
    topNavClick(stepItem, push);
  };

  return (
    <WithWizard
      render={({ next, previous, step, steps, go, push }) => (
        <ul
          className={`nav nav-tabs ${className}${disableNav ? ' disabled' : ''
            }`}
        >
          {steps.map((stepItem, index) => {
            if (!stepItem.hideTopNav) {
              return (
                <li
                  key={`topNavStep_${index}`}
                  className={`nav-item ${getClassName(
                    steps,
                    step,
                    index,
                    stepItem
                  )}`}
                >
                  <NavLink
                    className={'nav-link' + aiva !== undefined ? ' aiva' : ''}

                    to="#"
                    location={{}}
                    onClick={() => itemClick(stepItem, push)}
                  >
                    {aiva !== undefined ? <Fragment>  <div style={{ color: `${aiva !== undefined ? "rgb(227, 27, 120)" : ""}` }}> {stepItem.name}</div>
                      <div className='text-small' style={{ color: `${aiva !== undefined ? "black" : ""}`, marginBottom:`${aiva !== undefined ? "0.75rem" : ""}` }}>{stepItem.desc}</div></Fragment> :
                      <Fragment>  <span style={{ color: `${aiva !== undefined ? "rgb(227, 27, 120)" : ""}` }}> {stepItem.name}</span>
                        <small style={{ color: `${aiva !== undefined ? "black" : ""}` }}>{stepItem.desc}</small></Fragment>}
                  </NavLink>
                </li>
              );
            }
            return <span key={`topNavStep_${index}`} />;
          })}
        </ul >
      )}
    />
  );
};

export default TopNavigation;
